import { useLinked } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { ConfirmCreditNotesDataStep } from "../creditnotes/confirm-credit-notes-data-step";
import { ConfirmInvoicesDataStep } from "../invoices/confirm-invoices-data-step";
import { ConfirmUnappliedCashesDataStep } from "../unapplied-cashes/confirm-unapplied-cashes-data-step";

export const ConfirmMultiAssetsDataStep = ({
    isEdit, job, next, cancel, startOver, assetTypeMultiOptions, $refreshEvents }:
    { isEdit: boolean, job, next?, cancel?, startOver?, assetTypeMultiOptions, $refreshEvents }) => {
    const $assetTypeSelect = useLinked({ id: AssetType.invoice, name: 'Invoice' });

    const isInvoiceDataStep = (assetType) => {
        return assetType === AssetType.invoice;
    }

    const isCreditNoteDataStep = (assetType) => {
        return assetType === AssetType.creditNote;
    }

    const isUnappliedCashDataStep = (assetType) => {
        return assetType === AssetType.unappliedCash;
    }

    return <>
        {isInvoiceDataStep($assetTypeSelect.value.id) && <ConfirmInvoicesDataStep isEdit={isEdit} isAssetsModification={false} job={job} next={next} cancel={cancel} startOver={startOver} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} />}
        {isCreditNoteDataStep($assetTypeSelect.value.id) && <ConfirmCreditNotesDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} $refreshEvents={$refreshEvents} />}
        {isUnappliedCashDataStep($assetTypeSelect.value.id) && <ConfirmUnappliedCashesDataStep isEdit={isEdit} job={job} next={next} cancel={cancel} startOver={startOver} $assetTypeSelect={$assetTypeSelect} assetTypeMultiOptions={assetTypeMultiOptions} $refreshEvents={$refreshEvents} />}
    </>
}
